import React from 'react';

// Component
import { ResponsiveImage } from '@shopee-user/shared-customization-ui';

// Assets
import IconError1x from './error-1x.png';
import IconError1_5x from './error-1.5x.png';
import IconError2x from './error-2x.png';
import IconError3x from './error-3x.png';
import IconError4x from './error-4x.png';

const IconError = (): JSX.Element => {
  return (
    <ResponsiveImage
      srcSet={[
        { size: '1x', src: IconError1x },
        { size: '1.5x', src: IconError1_5x },
        { size: '2x', src: IconError2x },
        { size: '3x', src: IconError3x },
        { size: '4x', src: IconError4x },
      ]}
      defaultSrc={IconError1x}
    />
  );
};

export default IconError;
